/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// uuid is a library for generating unique id
import { v4 as uuidv4 } from "uuid";

// Kanban application components
import Card from "layouts/applications/kanban/components/Card";

const CreateBoards = (columnsObj = []) => {
  console.log("YOUR COLUMNS ARE: ", columnsObj);
  const sortedColumns = [...columnsObj].sort((a, b) => {
    if (a.order !== undefined && b.order !== undefined) {
      return a.order - b.order;
    }
    return 0;
  });

  const board = {
    columns: sortedColumns.map((board) => ({
      id: board.id,
      title: board.name,
      order: board.order, // Keep order information
      cards: [],
    })),
  };

  return board;
};

export const addCardsToBoard = (board, cards) => {
  if (Array.isArray(cards) && cards.length > 0) {
    cards.forEach((card) => {
      if (!card) return;

      // Map the API priority values to badge colors

      const cardTemplate = (
        <Card
          content={card.title || "No title provided"}
          attachedFiles={card.filesAttached}
          leadId={card.lead_id}
          cardId={card.id}
        />
      );

      // Get the column from board_id or fallback to column_id
      const position = card.board_id || "";

      // Find the column using board_id
      let columnIndex = board.columns.findIndex(
        (column) => column.title.toLowerCase() === position.toLowerCase()
      );

      // If column not found by board_id, try to find by column_id
      if (columnIndex === -1 && card.column_id) {
        columnIndex = board.columns.findIndex((column) => column.id === card.column_id.toString());
      }

      // If still not found, use the first column
      if (columnIndex === -1 && board.columns.length > 0) {
        columnIndex = 0;
      }

      if (columnIndex !== -1) {
        board.columns[columnIndex].cards.push({
          id: card.id.toString(),
          columnId: board.columns[columnIndex].id,
          toDoId: card.id,
          businessId: card.business_id,
          leadId: card.lead_id,
          template: cardTemplate,
          content: card.title,
          originalData: card,
        });
      }
    });
  }

  return board;
};
export default CreateBoards;
